import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Button,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  useDisclosure,
} from "@heroui/react";
import { GetSubscription } from "@/server-types";
import { Trans } from "@lingui/react/macro";
import { MoreHorizontal, Users } from "lucide-react";
import { getLocalizedValue } from "@/utils";
import { getTranslatedTimeframe } from "@/utils";
import SubscriptionVariationModal from "./SubscriptionVariationModal";

export const VariationCard = ({
  variation,
  subscription,
  onEdit,
}: {
  variation: GetSubscription["response"]["subscriptionVariations"][0];
  subscription: GetSubscription["response"];
  onEdit: () => void;
}) => {
  const { isOpen, onOpen, onClose, onOpenChange } = useDisclosure();

  return (
    <>
      <Card
        isPressable
        isHoverable
        onPress={onOpen}
        radius="sm"
        shadow="none"
        classNames={{
          base: "border-1 border-gray-200",
        }}
      >
        <CardHeader className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            <Users className="h-4 w-4" />
            <span className="text-xs">{variation.subscribersCount}</span>
          </div>
          <p className="font-semibold">{variation.priceCentsFormatted}</p>
        </CardHeader>
        <CardBody>
          <h3 className="flex items-center gap-2 text-xl font-medium">
            {getLocalizedValue(variation.nameLocalized)}
          </h3>
          <p className="text-xs">
            <Trans>Trajanje</Trans>:{" "}
            <span className="font-semibold">
              {variation.durationValue}{" "}
              {getTranslatedTimeframe(variation.durationUnit)}
            </span>
          </p>
          <p className="text-xs">
            <Trans>Omejitve</Trans>:{" "}
            {variation.limitations.length === 0 ? (
              <Trans>Ni omejitev</Trans>
            ) : (
              variation.limitations.map((limitation) => (
                <span key={limitation.id} className="font-semibold">
                  {limitation.limitAmount}/{" "}
                  {getTranslatedTimeframe(limitation.timeframe)}{" "}
                </span>
              ))
            )}
          </p>
        </CardBody>
        <CardFooter className="flex items-center justify-between">
          <div className="flex items-center"></div>
          <Dropdown shouldBlockScroll={false}>
            <DropdownTrigger>
              <Button isIconOnly variant="light">
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownTrigger>
            <DropdownMenu
              aria-label="Variation actions"
              onAction={(key) => {
                if (key === "edit") {
                  onEdit();
                }
              }}
            >
              <DropdownItem key="edit">
                <Trans>Uredi</Trans>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </CardFooter>
      </Card>

      <SubscriptionVariationModal
        variation={variation}
        subscription={subscription}
        isOpen={isOpen}
        onClose={onClose}
        onOpenChange={onOpenChange}
      />
    </>
  );
};
